export default "__VITE_ASSET__BKvfbRPH__"